import { reachYandexGoal } from 'utils/analytics/yandexMetrika'

/**
 * Send analytics event to Yandex.Metrika and dataLayer.
 * @param {string} eventName
 * @param {object} [params]
 */
export const sendEvent = (eventName, params) => {
  reachYandexGoal(eventName, params)

  if (global.dataLayer) {
    global.dataLayer.push({ event: eventName, ...params })
  }
}
